import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { PollData } from '../../../../providers/poll';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { IUser } from '../../../../models/user.model';
import * as clientSelectors from '../../../../ngrx/reducers/client.reducer';
import * as userSelectors from '../../../../ngrx/reducers/auth.reducer';
import { EventData } from '../../../../providers/event';
import { PageTrack } from '../../../../shared/decorators/analytics';
import uniqid from 'uniqid';

const uidTrack = uniqid();
const pageName = 'EventPollActiveComponent';

@Component({
  selector: 'app-event-poll-active',
  templateUrl: 'event-poll-active.html',
})
@PageTrack(uidTrack, pageName)
export class EventPollActiveComponent implements OnInit, OnDestroy {

  public clientId: string;
  public eventId: string;
  public pollId: string;
  public activePoll$: Observable<any>;
  public clientConfigSubs: Subscription;
  public eventSubs: Subscription;
  public pre_config: any;
  public userInformationSubs: Subscription;
  public userInformation: IUser;
  public showQuestions: boolean = false;

  constructor(
    private pollData: PollData,
    private navParams: NavParams,
    private store: Store<{}>,
    private viewCtrl: ViewController,
    private eventData: EventData
  ) { }

  ngOnInit() {
    this.clientId = this.navParams.get('clientId');
    this.eventId = this.navParams.get('eventId');
    this.pollId = this.navParams.get('pollId');
    this.getUserInformation();
    this.getPollActive();
    this.getClientConfig();
  }

  /**
   * Get User Information
   * @author Sebastián Guevara
   */
  private getUserInformation() {
    this.userInformationSubs = this.store.select(userSelectors.getUser)
      .subscribe((userInformation) => {
        this.userInformation = userInformation;
      })
  }

  private getEventConfig() {
    this.eventSubs = this.eventData.getEventInfo(this.clientId, this.eventId).subscribe((eventConfig) => {
      if (eventConfig && eventConfig.custom_style) {
        this.pre_config = eventConfig;
      }
    });
  }

  /**
   * Get Client Configuration
   * @author Sebastián Guevara
  */
  private getClientConfig() {
    this.clientConfigSubs = this.store.select(clientSelectors.getClientConfig)
      .subscribe((clientConfig) => {
        if (clientConfig) {
          this.pre_config = clientConfig;
          this.getEventConfig();
        }
      });
  }

  /**
   * Get Poll Active
   * Based on clientId and PollId
   * @author Sebastián Guevara
   */
  private getPollActive() {
    this.activePoll$ = this.pollData.getPollByClientId(this.clientId, this.pollId);
  }

  /**
   * Set showQuestions variable to show or not the questions
   * @param show
   * @author Sebastián Guevara
   */
  public setShowQuestions(show: boolean) {
    this.showQuestions = show;
  }

  /**
   * Close Modal
   * @author Sebastián Guevara
  */
  public closeModal() {
    this.viewCtrl.dismiss();
  }

  ngOnDestroy() {
    if (this.userInformationSubs) this.userInformationSubs.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/pages/poll-event/components/event-poll-active/event-poll-active.ts